import React, { Component } from 'react';
import { Paper } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Formatter from '../../utils/Formatter';
import AnalysisApi from '../../api/analysis';
import { connect } from 'react-redux';
import { showError, showMessage } from '../../actions/uiActions';
import AnalysisOutcome from '../AnalysisOutcome';

class Analysis extends Component {
  state = {
    processing: false,
    strategyForAll: false,
    planForAll: false,
    forgivenessApplyToAll: false,
    mode: 'default',
    loans: [],
    customAnalysisPreview: null,
  };

  update = async () => {
    this.setState({ processing: true });
    try {
      const updatedAnalysis = await AnalysisApi.update(this.props.id, this.state.loans);
      this.setState({ processing: false })
      this.props.showMessage('The strategy has been updated.');
      this.props.onEditedAnalysisSaved(updatedAnalysis);
      this.props.onClose();
    } catch (error) {
      this.setState({ processing: false }, this.props.showError)
    }
  }
  previewCustomAnalysis = async () => {
    try {
      const customAnalysisPreview = await AnalysisApi.getCustomAnalysisPreview(this.props.id, this.state.loans);
      this.setState({
        mode: 'preview',
        customAnalysisPreview,
      });
    } catch (error) {
      this.props.showError(error);
    }
  }
  closeCustomAnalysisPreview = () => {
    this.setState({
      mode: 'default',
      customAnalysisPreview: null,
    });
  }
  componentDidMount() {
    let allFlattenedLoans = [];
    if (this.props.analysis) {
      this.props.analysis.analysisDetails.forEach(eachAnalysis => {
        const recommendedPlan = eachAnalysis.plans.find(eachPlan => eachPlan.isPlanRecommended);
        const consolidationStrategy = eachAnalysis.strategy;
        let { loans } = eachAnalysis;
        if (consolidationStrategy === 0) {
          // for consolidation, the loans will have nested loans
          loans = eachAnalysis.loans[0].nestedLoans.map(eachNestedLoan => ({
            ...eachNestedLoan,
            consolidationGroupId: eachAnalysis.loans[0].id,
          }));
        }
        const formattedLoans = loans.map(eachLoan => ({
          ...eachLoan,
          consolidationStrategy,
          recommendedPlan: recommendedPlan && recommendedPlan.plan,
          forgivenessType: eachAnalysis.forgivenessType,
        }))
        allFlattenedLoans = allFlattenedLoans.concat(formattedLoans)
      });
    }
    this.setState({
      loans: allFlattenedLoans,
    });
  }
  getRepaymentPlan = loan => {
    return loan.recommendedPlan
  };
  getForgivenessType = loan => {
    return loan.forgivenessType
  };
  updateStateValue(isAppliedToAllKey, update, index) {
    let loans;
    if (this.state[isAppliedToAllKey]) {
      loans = this.state.loans.map(eachLoan => ({
        ...eachLoan,
        ...update,
      }));
    } else {
      ({ loans } = this.state);
      loans[index] = {
        ...loans[index],
        ...update,
      }
    }
    this.setState({ loans })
  }
  changeConsolidationStrategy({ target }, index) {
    this.updateStateValue("strategyForAll", { consolidationStrategy: parseInt(target.value) }, index)
  }
  changeForgivenessType({ target }, index) {
    this.updateStateValue("forgivenessApplyToAll", { forgivenessType: parseInt(target.value) }, index)
  }
  changeRecommendedPlan({ target }, index) {
    this.updateStateValue("planForAll", { recommendedPlan: parseInt(target.value) }, index)
  }
  render() {
    if (this.state.mode === "preview") {
      return <AnalysisOutcome
        account={this.props.account}
        preview={true}
        analysisCollection={this.state.customAnalysisPreview}
        onClose={this.closeCustomAnalysisPreview}
      />
    }
    return (
      <div className="padding animated fadeIn">
        <h2 className="text-center">Edit Strategy</h2>
        <div className="line-break"></div>
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className="width20pct">
                  <div>Recommended Strategy</div>
                  <div
                    className="checkbox-container"
                    onClick={() =>
                      this.setState({ strategyForAll: !this.state.strategyForAll })
                    }
                  >
                    <input checked={this.state.strategyForAll} type="checkbox" />{' '}
                    Apply to all
                  </div>
                </TableCell>
                <TableCell>Loan Type</TableCell>
                <TableCell>Balance</TableCell>
                <TableCell>Interest</TableCell>
                <TableCell>MMP</TableCell>
                <TableCell>
                  <div>Forgiveness</div>
                  <div
                    className="checkbox-container"
                    onClick={() =>
                      this.setState({ forgivenessApplyToAll: !this.state.forgivenessApplyToAll })
                    }
                  >
                    <input checked={this.state.forgivenessApplyToAll} type="checkbox" />{' '}
                    Apply to all
                  </div>
                </TableCell>
                <TableCell>
                  <div>Recommended Repayment Plan</div>
                  <div
                    className="checkbox-container"
                    onClick={() => this.setState({ planForAll: !this.state.planForAll })}
                  >
                    <input checked={this.state.planForAll} type="checkbox" /> Apply to
                    all
                  </div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                this.state.loans.map((loan, index) => (
                  <TableRow key={`${index}`}>
                    <TableCell className="marginless">
                      <select
                        disabled={this.state.processing}
                        onChange={(e) => this.changeConsolidationStrategy(e, index)}
                        value={loan.consolidationStrategy}
                        className="form-control"
                      >
                        <option value={1}>DO NOT CONSOLIDATE</option>
                        <option value={0}>CONSOLIDATE</option>
                      </select>
                    </TableCell>
                    <TableCell>{loan.type.name}</TableCell>
                    <TableCell>
                      ${Formatter.money(Formatter.moneyToNumber(loan.balance))}
                    </TableCell>
                    <TableCell>
                      ${Formatter.money(Formatter.moneyToNumber(loan.interest))}
                    </TableCell>
                    <TableCell>
                      ${Formatter.money(Formatter.moneyToNumber(loan.mmp))}
                    </TableCell>
                    <TableCell className="marginless">
                      <select
                        disabled={this.state.processing}
                        onChange={event => this.changeForgivenessType(event, index)}
                        value={this.getForgivenessType(loan)}
                        className="form-control"
                      >
                        <option value={5}>NONE</option>
                        <option value={0}>PSLF</option>
                        <option value={3}>TLF (5K)</option>
                        <option value={2}>TLF (17.5K)</option>
                        <option value={1}>PERKINS</option>
                        <option value={4}>IDR</option>
                      </select>
                    </TableCell>

                    <TableCell className="marginless">
                      <select
                        disabled={this.state.processing}
                        onChange={event => this.changeRecommendedPlan(event, index)}
                        value={this.getRepaymentPlan(loan)}
                        className="form-control"
                      >
                        {[0, 1, 2, 3, 4, 5, 6, 7, 10].map(plan => (
                          <option value={plan}>
                            {Formatter.repaymentPlanText(plan)}
                          </option>
                        ))}
                      </select>
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </Paper>
        <div className="line-break"></div>
        <div className="row">
          <div className="col-4 text-right">
            <button
              className="btn btn-secondary btn-standard"
              onClick={this.props.onClose}
            >
              Cancel
            </button>
          </div>
          <div className="col-4 text-center">
            <button
              className="btn btn-third btn-standard loading"
              onClick={this.previewCustomAnalysis}
              disabled={this.state.processing}
            >
              Preview Outcome
            </button>
          </div>
          <div className="col-4 text-left">
            <button
              className="btn btn-primary btn-standard loading"
              disabled={this.state.processing}
              onClick={this.update}
            >
              Update Strategy
            </button>
          </div>
        </div>
        <div className="line-break"></div>
      </div>
    )
  }
}
export default connect(null, { showError, showMessage })(Analysis);
